// extracted by mini-css-extract-plugin
module.exports = {"SideDrawer":"SideDrawer_SideDrawer__1IR3U","Open":"SideDrawer_Open__mykcf","Close":"SideDrawer_Close__1FmJM"};